export default __webpack_public_path__ + "static/admin-identity1-5f7d7df1dd51de724078d97875909882.png";